import { log } from 'log';
import { languageService } from 'js/services/language.service';

/**
 * Gets bonus title from bonus info
 * @function
 * @param [bonusData.bonusTemplate] {Object} contains bonus template info
 * @param [bonusData.bonus] {Object} contains bonus info
 * @param [options.lang] {String} current language
 * @returns {String}
 * @example getBonusTitle({  bonusTemplate, bonus }, { lang: 'en_GB' })
 */
export const getBonusTitle = ({ bonusTemplate, bonus }, { lang }) => {
    const imsMap = languageService.imsLocalesMappingInverted;

    if (!bonus && !bonusTemplate) {
        log('warn', 'No Bonus And Bonus Template');

        return '';
    }

    let bonusTemplateName = bonusTemplate?.name;
    let bonusName = bonusTemplate?.marketingName;
    const translations = bonusTemplate?.bonusTranslations || [];
    const twoLetterLang = languageService.getTwoLetterLanguage(lang);

    translations.forEach((item) => {
        const langCode = item.languageCode.toLowerCase();

        if (imsMap[langCode] === lang || langCode === twoLetterLang) {
            bonusName = item.marketingName || bonusName;
            bonusTemplateName = item.name || bonusTemplateName;
        }
    });

    return bonusName || bonus?.marketingName || bonus?.templateName || bonusTemplateName;
};
